module.exports = __webpack_public_path__ + "static/media/diamond.220f6fe7.png";